import type { HTMLAttributes } from 'react'

import cx from 'classnames'

import { AppVersion } from '../meta/app-version'
import { Copyright } from '../meta/copyright'

type PageFooterProps = HTMLAttributes<HTMLElement>

export function PageFooter({ className, ...rest }: PageFooterProps): JSX.Element {
  return (
    <footer
      className={cx('p-4 flex flex-col items-end gap-1', className)}
      data-page-footer
      {...rest}
    >
      <Copyright className='font-medium text-inherit' />
      <AppVersion commitsDirection='row' />
    </footer>
  )
}
